"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _constants = require("../utils/constants");

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _objectStatus = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/object-status.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _objectStatus.default));
/** *Object Status* is a short text that represents the semantic status of an object. It has a semantic color and an optional icon.
 * Typically, the object status is used in the dynamic page header and as a status attribute of a line item in a table. */

var ObjectStatus = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _context2, _classnames;

  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      glyph = _ref.glyph,
      indication = _ref.indication,
      inverted = _ref.inverted,
      link = _ref.link,
      onClick = _ref.onClick,
      size = _ref.size,
      status = _ref.status,
      props = (0, _objectWithoutProperties2.default)(_ref, ["ariaLabel", "children", "className", "cssNamespace", "glyph", "indication", "inverted", "link", "onClick", "size", "status"]);
  var objectStatusClasses = classnames("".concat(cssNamespace, "-object-status"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-object-status--indication-")).call(_context, indication), !!indication), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-object-status--inverted"), inverted), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-object-status--large"), size === 'l'), (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-object-status--")).call(_context2, status), !!status), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-object-status--link"), !!link || !!onClick), _classnames), className);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === ' ') onClick();
  };

  var StatusTag = 'span';
  var semanticProps = {};

  if (link !== null && link !== void 0 && link.length) {
    StatusTag = 'a';
    semanticProps.href = link;
  } else if (typeof onClick === 'function') {
    StatusTag = 'span';
    semanticProps.onClick = onClick;
    semanticProps.onKeyPress = handleKeyPress;
    semanticProps.role = 'button';
    semanticProps.tabIndex = 0;
  }

  return /*#__PURE__*/_react.default.createElement(StatusTag, (0, _extends2.default)({}, props, {
    "aria-label": ariaLabel,
    className: objectStatusClasses
  }, semanticProps, {
    ref: ref
  }), glyph && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: classnames("".concat(cssNamespace, "-object-status__icon")),
    glyph: glyph
  }), children && /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-object-status__text"))
  }, children));
});

ObjectStatus.displayName = 'ObjectStatus';
process.env.NODE_ENV !== "production" ? ObjectStatus.propTypes = {
  /**
   * aria-label is required for a11y, when object status has only icon
  */
  ariaLabel: function ariaLabel(props) {
    if (!props.children && !props.ariaLabel || !props.children && typeof props.ariaLabel !== 'string') return new Error('ariaLabel is required if there is no text inside the ObjectStatus component and must be a string');
  },

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** The icon to include. See the icon page for the list of icons */
  glyph: _propTypes.default.string,

  /** Generic Indication Colors which will appear on the text */
  indication: _CustomPropTypes.default.range(1, 8),

  /** Inverted Object Status(optional inverted visualization) determines whether the background color reflects
   * the set state instead of the control’s text. Use the inverted object status if the information is crucial
   * for the user’s actions and needs to stand out visually */
  inverted: _propTypes.default.bool,

  /** The link for the anchor tag */
  link: _propTypes.default.string,

  /** Size of the component:
  'l' */
  size: _propTypes.default.oneOf(_constants.OBJECT_STATUS_SIZES),

  /** Display the semantic status of an object: 'negative',
  'critical',
  'positive',
  'informative'*/
  status: _propTypes.default.oneOf(_constants.OBJECT_STATUS_TYPES),

  /**
   * Callback function; triggered when user clicks on the ObjectStatus.
   * This is not supported for links as they are supposed to navigate.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onClick: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(ObjectStatus);

exports.default = _default;